var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreBenefitsDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.668 2.5V57.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.168 12.5H24.418C22.0973 12.5 19.8717 13.4219 18.2308 15.0628C16.5898 16.7038 15.668 18.9294 15.668 21.25C15.668 23.5706 16.5898 25.7962 18.2308 27.4372C19.8717 29.0781 22.0973 30 24.418 30H36.918C39.2386 30 41.4642 30.9219 43.1052 32.5628C44.7461 34.2038 45.668 36.4294 45.668 38.75C45.668 41.0706 44.7461 43.2962 43.1052 44.9372C41.4642 46.5781 39.2386 47.5 36.918 47.5H15.668",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreBenefitsDollar);
export default __webpack_public_path__ + "static/media/core-benefits-dollar.05afa80e28eed7c410d9b1c41d89da6c.svg";
export { ForwardRef as ReactComponent };